var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.905 22.44a9.07 9.07 0 01-5.864 2.133c-4.993 0-9.041-4-9.041-8.933 0-4.934 4.048-8.933 9.04-8.933a9.07 9.07 0 015.865 2.134 9.07 9.07 0 015.865-2.134c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 01-5.865-2.134z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.905 22.44a8.87 8.87 0 003.177-6.8 8.87 8.87 0 00-3.177-6.8 9.07 9.07 0 015.865-2.133c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 01-5.865-2.134z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.905 22.44a8.87 8.87 0 003.177-6.8 8.87 8.87 0 00-3.177-6.8 8.87 8.87 0 00-3.176 6.8 8.87 8.87 0 003.177 6.8z",
    fill: "#FF5E00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}
export default SvgMasterCard;